<template>
    <a :href="computedHref" :class="classes" @click.prevent="handleClick" tabindex="-1">
        <template v-if="theme === 'none'">
            <icon v-if="icon" :name="icon"/>
            <slot>{{ label }}</slot>
        </template>
        <template v-else>
            <icon v-if="icon" :name="icon" class="btn-icon"/>
            <div v-if="$slots.default || $scopedSlots.default || label !== ''" class="btn-label">
                <slot>{{ label }}</slot>
            </div>
        </template>

    </a>
</template>

<script>
    export default {
        mixins: [
            require('../mixins/linkMixin').default,
        ],

        props: {
            theme: {type: String, default: 'primary'},
            size: {type: String, default: null},
            outline: {type: Boolean, default: false},
        },

        computed: {
            hasLabel() {
                return this.$slots.default || this.$scopedSlots.default || this.label;
            },

            classes() {
                let classes = [];

                if (this.isActive) {
                    classes.push('active');
                }

                if (this.theme !== 'none') {
                    classes.push('btn');

                    if (this.outline) {
                        classes.push(`btn-outline-${this.theme}`);
                    } else {
                        classes.push(`btn-${this.theme}`);
                    }
                    if (this.icon && !this.hasLabel) {
                        classes.push('btn-only-icon');
                    }
                    if (this.size !== null) {
                        classes.push(`btn-${this.size}`);
                    }
                }

                return classes;
            },
        },
    };
</script>